<template>
  <div class="Editor-Smiles-Module">
    <button class="Editor-Smiles-Module__btn" @click="toToggle" ref="toggleBtn" type="button">
      <SmileInputIcon />
    </button>
    <transition name="Anim__fadeUp">
      <div class="Editor-Smiles-Module__dropdown" ref="dropdown" v-if="isOpen">
        <EditorSmilesDropdown :maxHeight="280" @smile="toSendSmile"/>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  //-------------------------------------
  import SmileInputIcon from '@svg/SmileInputIcon.vue';
  import EditorSmilesDropdown from './components/Dropdown/EditorSmilesDropdown.vue';
  //-------------------------------------
  const emit = defineEmits();
  //-------------------------------------
  const isOpen = ref(false);
  const dropdown = ref(null);
  const toggleBtn = ref(null);
  //-------------------------------------
  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
  //-------------------------------------
  //Отправить полученный смайл на выход
  const toSendSmile = (smile) => {
    emit('smile', smile);
  }
  //Открытие/закрытие дропдауна
  const toToggle = (event) => {
    event.stopPropagation();
    isOpen.value = !isOpen.value;
    isOpen.value ? emit('open') : emit('close');
    emit('clickTrigger');
  };
  //Проверка, был ли клик вне доступной области
  const handleClickOutside = (e) => {
    if (dropdown.value && !dropdown.value.contains(e.target) && !toggleBtn.value.contains(e.target) && !toCheckClickToTheTextarea(e)) {
      isOpen.value = false;
      emit('close')
    }
  };
  /*
    Дополнительная проверка, которая предотваращает закрытие дропдауна, если клик был произведен по текстовому полю, 
    к которому принадлежит этот дропаун со смайликами
  */
  const toCheckClickToTheTextarea = (e) => {
    const form = e.target.closest('[data-parent-comments-form-field]') || 
                 e.target.closest('.ProseMirror');
    return form ? true : false;
  }
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>